import { useCallback, ChangeEvent } from 'react'
import { useDispatch } from 'react-redux'
import { Optional } from 'packages/types'
import { useI18n } from 'builder/hooks/useI18n'
import { TextField } from 'builder/components/TextField'
import EditorField from 'builder/components/EditorField'
import { actions as editorActions } from 'builder/modules/resumeEditor'

type Props = {
  postalCode: Optional<string>
}

export const PostalCode = (props: Props) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { postalCode } = props
  const handleSimpleFieldUpdate = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target
      dispatch(editorActions.updateSimpleField({ name: 'postalCode', value, debounce: true }))
    },
    [dispatch],
  )

  return (
    <>
      {/* ZIP Code */}
      <EditorField>
        <TextField
          label={i18n.t('builder.resume_editor.postal_code')}
          value={postalCode || ''}
          name="postalCode"
          onChange={handleSimpleFieldUpdate}
        />
      </EditorField>
    </>
  )
}
